import Decimal from 'decimal.js'
import { MDBTooltip } from 'mdb-react-ui-kit'

// 1,000.00  //hover
export function formatNumber(number, type = 'thousand') {
  if (number === null || number === undefined || number === '' || number == 0) return 0

  const clean = String(number).replace(/,/g, '')

  const value = new Decimal(clean)

  // ---------- ALPHABET (k, M, B...) ----------
  if (type === 'alphabet') {
    const units = ['k', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y']

    for (let i = units.length - 1; i >= 0; i--) {
      const decimal = new Decimal(1000).pow(i + 1)

      if (value.abs().gte(decimal)) {
        const number = value.div(decimal).toDecimalPlaces(2, Decimal.ROUND_HALF_UP)

        if (number.mod(1).equals(0)) {
          return `${number.toFixed(0)}${units[i]}`
        }

        return `${number.toFixed(2)}${units[i]}`
      }
    }

    // fix here
    if (value.mod(1).equals(0)) {
      return value.toFixed(0)
    }

    return value.toDecimalPlaces(2).toFixed(2)
  }

  const rounded = value.toDecimalPlaces(2, Decimal.ROUND_HALF_UP)

  const hasDecimal = !rounded.mod(1).equals(0)

  return rounded
    .toNumber()
    .toLocaleString(
      undefined,
      hasDecimal
        ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        : { minimumFractionDigits: 0, maximumFractionDigits: 0 },
    )
}

//   const checkNumber = number ? String(number) : "0.00";

//   if (checkNumber.includes(",")) {
//     let numberString = checkNumber.replace(/,/g, "");
//     let [integerPart, decimalPart] = numberString.split(".");

//     if (decimalPart) {
//       decimalPart = decimalPart.substring(0, 2); // Take only first two digits
//     } else {
//       decimalPart = "00"; // If no decimal part, add '.00'
//     }

//     const formattedNumber = parseFloat(integerPart + "." + decimalPart).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//     return (
//     //   <MDBTooltip tag={"a"} title={checkNumber}>
//       formattedNumber
//         //  </MDBTooltip>
//     )
//   } else {
//     let numberString = checkNumber.replace(/,/g, "");

//     let [integerPart, decimalPart] = numberString.split(".");

//     if (decimalPart) {
//       decimalPart = decimalPart.substring(0, 2); // Take only first two digits
//     } else {
//       decimalPart = "00"; // If no decimal part, add '.00'
//     }

//     const formattedNumber = parseFloat(integerPart + "." + decimalPart).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     return (
//     //   <MDBTooltip tag={"a"} title={checkNumber}>
//       formattedNumber
//         //  </MDBTooltip>
//     )
//   }
// }
